import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { ResidenceContactEntityState } from '@_model/interfaces/residence-contact.model';

export interface ResidenceContactState extends EntityState<ResidenceContactEntityState> {
  isLoaded: boolean;
  isLoading: boolean;
  actives: number[];
}

export const adapter: EntityAdapter<ResidenceContactEntityState> = createEntityAdapter<ResidenceContactEntityState>({
  selectId: o => o.idResidenceContact
});
export const initialState: ResidenceContactState = adapter.getInitialState({
  isLoaded: false,
  isLoading: false,
  actives: []
});

export const residenceContactFeatureKey = 'residenceContact';
